module.exports = __webpack_public_path__ + "img/logo.b85af187.png";